import { Button } from '@nimbus-ds/components';
import { InitialScreen } from '@nimbus-ds/patterns';
import { useNavegate } from 'App/hooks';
import useTranslationCatalog from 'domains/Catalog/useTranslationCatalog';
import emptyInventory from './empty-inventory.png';

function InventoryEmpty(): JSX.Element {
  const t = useTranslationCatalog();
  const { goTo } = useNavegate();
  const handleClick = () => goTo('/products');

  return (
    <InitialScreen>
      <InitialScreen.Hero
        subtitle={t('inventory.title').toUpperCase()}
        title={t('inventory.emptyLocation.title')}
        description={t('inventory.emptyLocation.body')}
        image={
          <img
            src={emptyInventory}
            width="100%"
            height="auto"
            alt="empty-products"
          />
        }
        actions={
          <Button as="a" onClick={handleClick} appearance="primary">
            {t('inventory.emptyLocation.action')}
          </Button>
        }
      />
    </InitialScreen>
  );
}

export default InventoryEmpty;
